export const NEW_SIGNATURE_STEPS = {
  mobileAndEmail: {
    id: 1,
    title: 'Your details',
    step: 1,
  },
  verify: {
    id: 2,
    title: 'Enter OTP',
    step: 2,
  },
  photo: {
    id: 3,
    title: 'Your photo',
    step: 3,
  },
  signeeInfo: {
    id: 4,
    title: 'Complete doc',
    step: 4,
  },
  success: {
    id: 5,
    title: 'Success',
    step: 5,
  },
};

export const DOC_VIEWER_STEPS = {
  mobileAndEmail: {
    id: 1,
    title: 'Your details',
    step: 1,
  },
  verify: {
    id: 2,
    title: 'Enter OTP',
    step: 2,
  },
  docs: {
    id: 3,
    title: 'Docs',
    step: 3,
  },
};

export const SIGNATURES_PAGE_LIMIT = 5;

export const RE_DIGIT = new RegExp(/^\d+$/);
